module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称、出版物名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, 'time')) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, 'record_state')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.record == 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goRegist(scope.row)
            }
          }
        }, [_vm._v("登记\n              ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goScan(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位登记")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e91647"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provinceRole/successivePgress/successiveRegist.vue
// module id = 1727
// module chunks = 1